import Success from "./Success";
import PreApproved from "./PreApproved";
import ExisitingOffer from "./ExisitingOffer";
import OfferCalculator from "./OfferCalculator";
import CreateCustomer from "./CreateCustomer/CreateCustomer";
import LeadCreated from "./CreateCustomer/LeadCreated";
import LeadSuccess from "./CreateCustomer/LeadSuccess";

export type SliderContainerType = {
  current: string;
  pageName: string;
  close: () => void;
};

export default function SliderContainer(props: SliderContainerType) {
  let component;

  switch (props?.current) {
    case "pre-approved-loan-offer":
      component = <PreApproved {...props} />;
      break;
    case "existing-offers":
      component = <ExisitingOffer {...props} />;
      break;
    case "success":
      component = <Success {...props} />;
      break;
    case "offer-calculator":
      component = <OfferCalculator {...props} />;
      break;
    case "create-customer":
      component = <CreateCustomer {...props} />;
      break;
    case "lead-created":
      component = <LeadCreated {...props} />;
      break;
    case "lead-success":
      component = <LeadSuccess {...props} />;
      break;

    default:
      component = null; // Handle invalid currentActiveSlider value
      break;
  }

  return component;
}
